import React from 'react'
import FontAwesome from 'react-fontawesome'
import styled from 'styled-components'
import { PRIMARY_LIGHT } from '../../styles/colors.style'
import {
	shadow,
	blueGradient,
	dangerGradient,
	orangeGradient,
	squareOrangeButton,
} from '../../styles/reusable.style'
import { isBlackFriday } from '../../helpers/isBlackFriday'

const getStyle = ({ primary, secondary, danger, link, color, withShadow }) => {
	if (primary) {
		return `
            ${withShadow ? shadow() : ''}
            background: ${isBlackFriday ? 'black' : orangeGradient()};
            border: none;
        `
	} else if (secondary) {
		return `
            ${withShadow ? shadow() : ''}
            background: ${blueGradient()};
            border: none;
        `
	} else if (danger) {
		return `
            ${withShadow ? shadow() : ''}
            background: ${dangerGradient()};
            border: none;
        `
	} else if (link) {
		return `
            color: ${color || PRIMARY_LIGHT};
            background: transparent;
            border: none;
            font-size: 1.8rem;
            outline: 0;
            text-decoration: underline;  
        `
	} else {
		return `
            background: transparent;
            border: 2px solid white;
        `
	}
}

/**
 * @param {boolean} primary
 * Applies primary style:
 * Orange and yellow gradient background.
 *
 * @param {boolean} secondary
 * Applies secondary style:
 * Dark blue and blue gradient background.
 *
 * @param {boolean} danger
 * Applies danger style:
 * Dark red and red gradient background.
 *
 * @param {boolean} link
 * Aplies link style:
 * Text underlined
 *
 * @param {string} color
 * Applies color to the font: only if link is true
 *
 * @param {boolean} withShadow
 * Applies box-shadow
 */
const Button = styled.button`
	${squareOrangeButton}
	${getStyle}
`

const StyledPlayButton = styled.div`
	color: #fff;
	background: ${orangeGradient()};
	display: inline-flex;
	justify-content: center;
	align-items: center;
	height: 22.7rem;
	width: 22.7rem;
	border-radius: 22.7rem;
	box-shadow: 0px 20px 40px rgba(0, 0, 0, 0.3);
	transition: all 0.5s;

	&:hover {
		cursor: pointer;
		transform: scale(1.05);
		box-shadow: 0px 40px 40px rgba(0, 0, 0, 0.3);
	}

	.fa {
		font-size: 14em;
		margin-left: 3rem;
	}
`

export const PlayButton = (props) => (
	<StyledPlayButton className="play-button" {...props}>
		<FontAwesome name="play" size="4x" />
	</StyledPlayButton>
)

export default Button
